import React, { memo } from 'react';
import styles from 'Custom/Table/index.module.scss';
import RichText from 'Custom/RichText/index';

const TABLE_SIZE = {
  default: styles.default,
  sm: styles.sm,
  compact: styles.compact,
};

const Table = ({
  className = 'default',
  title = '',
  content = [],
  children,
  ...props
}) => {
  const baseClassName = TABLE_SIZE[className] || TABLE_SIZE.default;

  return (
    <section className={`${styles.wrapper} ${baseClassName}`} {...props}>
      {content && (
        <RichText>
          <table aria-label={title}>
            <tbody>
              {content.map((item, i) => (
                <tr key={`table-row-${i}`}>
                  <th className={styles.tableCell}>{item.title}</th>
                  <td className={styles.tableCell}>{item.body}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </RichText>
      )}
    </section>
  );
};

const MemoTable = memo(Table);

export { MemoTable as Table };
